import React from 'react';
import "./response.css";
import {getColor} from "../../utilities/getColor";


const Response = (
  {
    header,
    value,
    terms,
    hbIndex,
    primaries,
    score,
    showContextMenu,
    setSelectedText
  }
) => {
  return (
    <div className="response_component">
      <div className="response_component__header">
        <div className="response_component__header__header">
          <span className="key">Header:</span>
          <span>{ header }</span>
        </div>
        <div className="response_component__header__hb_index">
          <span className="key">HX Index:</span>
          <span>{hbIndex}</span>
        </div>
        {
          score ?
            <div className="response_component__header__score">
              <span className="key">Score:</span>
              <span>{score}</span>
            </div>
            :
            null
        }
      </div>
      <div className="response_component__value">
        <span onContextMenu={e => {
          e.preventDefault();
          e.stopPropagation();
          setSelectedText();
          showContextMenu({top: e.clientY, left: e.clientX})
        }} >{value}</span>
      </div>
      <div className="response_component__words">
        <span className="key">Words:</span>
          {
            terms.map((term, i) => <span key={i} className="tag">{term}</span>)
          }
      </div>
      <div className="response_component__primaries">
        <span className="key">Primaries:</span>
        {
          primaries.map((primary, i) => <span style={{color: 'white', backgroundColor: getColor(
            {
              primary: true,
              fromd3: false,
              d: {
                primary: `${primary[0].toUpperCase()}${primary.slice(1)}`
              }
            }
          )}} key={i} className="tag">{primary}</span>)
        }
      </div>


    </div>
  )
};


export default Response;


// WEBPACK FOOTER //
// ./src/components/response/response-component.js